import { useGet, useSend } from '../../useApi';

export interface PasskeyList {
  passkeys: { id: string; name: string; created_at: string; last_used_at: string | null; backed_up: boolean; transports: string[] }[];
  recovery_codes_left: number;
  max_passkeys: number;
}

// The signed-in admin's passkeys (ops spec K step 9): list and rename here;
// adding, removing and new recovery codes go through the page's passkey
// re-check, using `send`.
const usePasskeys = () => {
  const { data, loading, fetch } = useGet<PasskeyList>('Failed to load passkeys');
  const { loading: busy, send } = useSend('Something went wrong');
  const fetchPasskeys = () => fetch('api/v1/admin/passkeys');
  return {
    list: data,
    loading,
    busy,
    fetchPasskeys,
    send,
    rename: (id: string, name: string) =>
      send({ url: `api/v1/admin/passkeys/${id}`, method: 'patch', data: { name } }, fetchPasskeys),
  };
};

export default usePasskeys;
